module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/criminal-proceedings/criminal-proceed-grid/criminal-proceed-grid.component.css
// module id = ./src/app/pages/functions/criminal-proceedings/criminal-proceed-grid/criminal-proceed-grid.component.css
// module chunks = main